import { useHistory } from 'react-router-dom'

const useResetHistoryStateValue = (value) => {
  const history = useHistory()

  const resetHistoryStateValue = () => {
    history.replace({
      ...history.location,
      state: {
        ...history.location.state,
        [value]: null,
      },
    })
  }

  return resetHistoryStateValue
}

export default useResetHistoryStateValue
